import { render, staticRenderFns } from "./OtherCashesEditForm.vue?vue&type=template&id=04ec5cbb"
import script from "./OtherCashesEditForm.vue?vue&type=script&lang=js"
export * from "./OtherCashesEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports